var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.system.isPhone ? 'wap_form_bar wapfont18' : 'form_bar'},[(_vm.textNone != '0')?_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.$t("applyAgent." + _vm.whoApply + _vm.name))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }